import { render, staticRenderFns } from "./VendorDashboardProvider.vue?vue&type=template&id=812204c6&scoped=true"
import script from "./VendorDashboardProvider.vue?vue&type=script&lang=ts"
export * from "./VendorDashboardProvider.vue?vue&type=script&lang=ts"
import style0 from "./VendorDashboardProvider.vue?vue&type=style&index=0&id=812204c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812204c6",
  null
  
)

export default component.exports